import { render } from "./ResponseList.vue?vue&type=template&id=56fe0264"
import script from "./ResponseList.vue?vue&type=script&lang=js"
export * from "./ResponseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__